import {useAuth} from "@/context/use-auth.tsx";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {Button} from "@/components/tailwind/button.tsx";
import {Heading} from "@/components/tailwind/heading.tsx";
import {useUsersTranslation} from '@/i18n/hooks';
import {DataTable} from "@/components/data-table.tsx";
import {columns, UserAccount} from "@/pages/admin/users/users-columns.tsx";
import {getUsers} from "@/services/user-services.ts";
import {Plus} from "lucide-react";


export default function UsersPage() {
    const {token, isAdmin} = useAuth()
    const [users, setUsers] = useState<UserAccount[]>([])
    const {t} = useUsersTranslation();

    const navigate = useNavigate()

    useEffect(() => {
        if (!isAdmin()) {
            navigate("/dashboard")
            return
        }

        const usersFromServer = getUsers(token!)

        usersFromServer.then((users) => setUsers(users as UserAccount[]))
    }, [isAdmin, navigate, token])

    if (!isAdmin()) {
        return null
    }

    return (
        <div className="container mx-auto py-6">
            <div className="flex justify-between items-center mb-6">
                <Heading>{t('userList.mainHeader')}</Heading>
                <Button 
                    href="/admin/users/new" 
                    className="flex items-center" 
                    data-testid="add-user-button"
                    aria-label={t('userList.newUserButton.ariaLabel')}
                >
                    <Plus className="h-4 w-4 mr-1"/>
                    {t('userList.newUserButton.title')}
                </Button>
            </div>
            <DataTable 
                columns={columns} 
                data={users} 
                data-testid="users-table"
                getRowTestId={(user) => `user-row-${user.id}`}
                getRowTestData={(user) => ({
                    username: user.username,
                    name: user.name,
                    role: user.role
                })}
            />
        </div>
    )
}
